import { useEffect, useState } from 'react';

const STORAGE_KEY = 'pilates_factory_cookie_consent';

const updateGoogleConsent = (granted) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_update',
    consent_state: granted ? 'granted' : 'denied',
  });
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      analytics_storage: granted ? 'granted' : 'denied',
      ad_storage: granted ? 'granted' : 'denied',
      ad_user_data: granted ? 'granted' : 'denied',
      ad_personalization: granted ? 'granted' : 'denied',
    });
  } else {
    window.dataLayer.push([
      'consent',
      'update',
      {
        analytics_storage: granted ? 'granted' : 'denied',
        ad_storage: granted ? 'granted' : 'denied',
        ad_user_data: granted ? 'granted' : 'denied',
        ad_personalization: granted ? 'granted' : 'denied',
      },
    ]);
  }
};

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem(STORAGE_KEY);
    if (savedConsent === 'granted') {
      updateGoogleConsent(true);
    } else if (savedConsent === 'denied') {
      updateGoogleConsent(false);
    } else {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'granted');
    updateGoogleConsent(true);
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, 'denied');
    updateGoogleConsent(false);
    setVisible(false);
  };

  if (!visible || window.location.pathname.startsWith('/admin')) return null;

  return (
    <section
      role="dialog"
      aria-label="Cookie-beállítások"
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] border-t border-[#c9c2b8] bg-[#faf8f5] p-5 shadow-2xl"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="max-w-3xl">
          <h2 className="font-semibold text-[#16181b]">Cookie-beállítások</h2>
          <p className="mt-1 text-sm leading-relaxed text-[#5c5a57]">
            Analitikai cookie-kat használunk a weboldal működésének, az árkalkulátor
            használatának és a sikeres ajánlatkérések mérésére. A mérési rendszerbe nem
            továbbítunk nevet, e-mail-címet vagy telefonszámot.
          </p>
        </div>
        <div className="flex shrink-0 gap-3">
          <button
            type="button"
            onClick={reject}
            data-testid="cookie-reject-btn"
            className="rounded-xl border border-[#8c8882] px-5 py-3 text-sm font-semibold text-[#16181b]"
          >
            Elutasítom
          </button>
          <button
            type="button"
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="rounded-xl bg-[#a45f49] px-5 py-3 text-sm font-semibold text-white"
          >
            Elfogadom
          </button>
        </div>
      </div>
    </section>
  );
}
